// extracted by mini-css-extract-plugin
export default {"ruler":"ruler_ruler__AK-06"};